export const matchStrings = (id, value) => {
  return String(id).toLowerCase() === String(value).toLowerCase()
}